import {
  type GraphPath,
  IPF_NETWORK_VIEWER,
  type NodeData,
  type NodeId,
  type NodeRecord,
} from '@ipfabric/utils';
import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';

export const addCollapsedHiddenNodes =
  (nodes: NodeRecord, oldNodes?: NodeRecord) =>
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
  (hiddenNodes: Set<NodeId>): Set<NodeId> => {
    if (!oldNodes) {
      return hiddenNodes;
    }

    const collapsedHiddenNodeIds: Set<NodeId> = new Set(hiddenNodes);
    const nodesByParentPath: Map<GraphPath, NodeData[]> = new Map();

    const clouds = pipe(
      nodes,
      record.filter(({ parentPath }) => parentPath === IPF_NETWORK_VIEWER),
      Object.values,
    );

    for (const node of Object.values(oldNodes)) {
      if (node.parentPath !== null) {
        const nodesInPath = nodesByParentPath.get(node.parentPath);
        if (nodesInPath) {
          nodesInPath.push(node);
        } else {
          nodesByParentPath.set(node.parentPath, [node]);
        }
      }
    }

    for (const { id, path } of clouds) {
      const childNodes = nodesByParentPath.get(path) ?? [];

      const allHidden = childNodes.every((node) => hiddenNodes.has(node.id));

      if (Object.entries(childNodes).length > 0 && allHidden) {
        collapsedHiddenNodeIds.add(id);
      }
    }

    return collapsedHiddenNodeIds;
  };
